import React from 'react'
import Logo from '../images/accelor-nobg11.png'
import { IoLocation, IoMail, IoCall } from "react-icons/io5";
import { Link, useLocation } from 'react-router-dom';
function Footer() {
    const location = useLocation()
    let bgColor;
    if (location.pathname === '/infrastructure/ess') {
        bgColor = 'bg-gray-200'
    }
    else if (location.pathname === '/') {
        bgColor = 'bg-gray-200'
    }

    else {
        bgColor = 'bg-gray-100'
    }
    return (
        <div className=''>
            {location.pathname === '/Products' ? '' :
                <svg className={`relative top-0 rotate-180 ${bgColor}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" fill="#425472"><path d="M0 0v100c166.7 0 166.7-66 333.3-66S500 77 666.7 77 833.3 28 1000 28V0H0Z" opacity=".5"></path><path d="M0 0v100c166.7 0 166.7-66 333.3-66S500 70 666.7 70 833.3 16 1000 16V0H0Z" opacity=".5"></path><path d="M0 0v100c166.7 0 166.7-66 333.3-66S500 63 666.7 63 833.3 4 1000 4V0H0Z"></path></svg>
            }
             <div className='bg-[#425472] h-[auto]  px-[10%] py-7 max-sm:px-4 flex items-center justify-center  text-white'>

                <div className='flex max-sm:flex-col flex-wrap w-full items-center justify-between gap-10'>
                    <img className='' src={Logo} alt='logo' height='250' width='250' />
                    {/* <h1 className='poppins text-[3rem] font-bold'>ACCELOR<br /></h1> */}
                    <div className='max-sm:text-[14px] flex gap-10 max-sm:flex max-sm:gap-8'>
                        <div className='flex flex-col'>

                            <Link to='/'>Home</Link>
                            <Link to='/about-us'>About</Link>
                            <Link to='infrastructure'>Infrastructure</Link>
                        </div>
                        <div className='flex flex-col'>

                            <Link to='Products'>Products</Link>
                            {/* <Link to='careers'>Careers</Link> */}
                            <Link to='contact'>Contact</Link>
                        </div>
                    </div>

                    <div className='flex flex-col max-sm:text-[14px] gap-4 items-start'>
                        <h1 className='font-bold uppercase'>Contact us</h1>
                        <div className='flex gap-2'>
                            <span><IoLocation size={25} color='white' /></span>
                            <p>
                                F451, Phase-8B, Industrial Focal Point, <br />SAS Nagar, Mohali, Punjab-160055
                            </p>
                        </div>

                        <div className='flex gap-2'>
                            <span><IoMail size={25} color='white' /></span>
                            <p>
                                contact@accelorindia.com
                            </p>
                        </div>

                        <div className='flex gap-2'>
                            <span><IoCall size={25} color='white' /></span>
                            <p className='text-left'>+91 7080229840/42</p>
                            <p className='text-left'>+91 7080229843/44 (AMETL)</p>
                        </div>
                    </div>
                </div>

                {/* <div>
                <h1 className='font-bold'>Accelor Microsystems Private Limited</h1>
                
                </div> */}

            </div>
        </div>
    )
}

export default Footer